module.exports = __webpack_public_path__ + "b945822bd3853929970076d52d42e0fa.svg";